module.exports = __webpack_public_path__ + "media/images/shopify_faq_6-79b308de8d589d1039079030d53d3e62.png";